var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00132 7.42763L4.25411 7.29277L4.77663 8.33783L5.67001 7.02304L3.91702 4.37653L1.23689 0.28045C1.11884 0.0950245 0.849229 0.0276535 0.663809 0.145584C0.0907249 0.482681 -0.145264 1.17382 0.0907249 1.78065L2.02914 6.7364C2.31568 7.52865 3.25962 7.84895 4.00133 7.42754L4.00132 7.42763Z",
    fill: "#636F7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27093 9.45068L6.31006 11.4229L8.29904 15.4347C8.6024 16.0415 9.34411 16.2775 9.93411 15.9404L10.0352 15.873C10.6253 15.5359 10.8107 14.7605 10.4229 14.2042L7.27093 9.45068Z",
    fill: "#636F7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8897 1.52781C11.7211 1.37613 11.4683 1.42669 11.3502 1.61212C11.3502 1.61212 9.83323 4.12374 9.39487 4.83167C9.3275 4.93279 9.19263 4.96654 9.09152 4.91598C8.9904 4.8486 8.93984 4.71374 9.00721 4.61262C9.4118 3.87092 10.8109 1.30879 10.8109 1.30879C10.912 1.12336 10.8277 0.887378 10.6087 0.803067C10.457 0.752507 10.2884 0.819881 10.2041 0.954746L8.24872 4.1743C8.18134 4.27542 8.04648 4.30917 7.94536 4.25861C7.84424 4.19123 7.79368 4.05637 7.86106 3.95525C8.26564 3.21355 9.66474 0.651417 9.66474 0.651417C9.76586 0.465992 9.68156 0.230009 9.4625 0.145698C9.31082 0.0951377 9.1422 0.162511 9.05792 0.297377L6.98462 3.70235L6.73183 4.1575C6.4621 4.61265 6.37779 5.152 6.49585 5.5734L6.74864 6.48358L1.54004 14.1869C1.1692 14.76 1.3378 15.5185 1.92771 15.8557L2.02883 15.9231C2.61886 16.2602 3.37736 16.0411 3.66389 15.4174L7.72626 7.05665L8.63644 6.82066C9.07468 6.70261 9.47926 6.36551 9.74899 5.91048L10.0018 5.45533L11.9066 1.96608C12.0413 1.8144 12.0245 1.62898 11.8896 1.52784L11.8897 1.52781Z",
    fill: "#636F7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/F&B.040eeccec224accaafb29fee9da4fcd6.svg";
export { ForwardRef as ReactComponent };